import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { OWCC_LOCAL_STORAGE_KEY } from '../../config/web-storage.config';
import { LocalStorageService } from '../../services/storage/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DevModeService {
  private readonly devModeSubject: BehaviorSubject<boolean>;

  public constructor(private readonly localStorageService: LocalStorageService) {
    const isDevMode = this.localStorageService.get<boolean>(OWCC_LOCAL_STORAGE_KEY.DEV_MODE) || false;
    this.devModeSubject = new BehaviorSubject<boolean>(isDevMode);
    this.isDevMode$.subscribe(() => {
      this.saveDevMode();
    });
  }

  public get isDevMode$(): Observable<boolean> {
    return this.devModeSubject.asObservable();
  }

  public get isDevMode(): boolean {
    return this.devModeSubject.getValue();
  }

  public enableDevMode(): void {
    this.devModeSubject.next(true);
  }

  public disableDevMode(): void {
    this.devModeSubject.next(false);
  }

  public toggleDevMode(): void {
    this.devModeSubject.next(!this.isDevMode);
  }

  private saveDevMode(): void {
    // if dev mode is false and not already existing in storage, do not save
    if (
      !this.devModeSubject.getValue() &&
      this.localStorageService.get(OWCC_LOCAL_STORAGE_KEY.DEV_MODE) === undefined
    ) {
      return;
    }
    this.localStorageService.set(OWCC_LOCAL_STORAGE_KEY.DEV_MODE, this.devModeSubject.getValue());
  }
}
